import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  CardActions,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router";
import MainContainer from "../../../components/MainContainer";
import AppStepper from "../../../components/reusable/AppStepper";
import { headerDataAdmin } from "../../../data/modules/admin-header";
import ChoixLocalisation from "./ChoixLocalisation";
import DiplomeRequisPage from "./DiplomeRequisPage";
import DomaineSousDomainePage from "./DomaineSousDomainePage";
import InformationAMiPage from "./InformationAMiPage";
import Resume from "./Resume";

const CreationAMI = () => {
  const [currentPage, setCurrentPage] = React.useState(0);
  const [isSaving, setIsSaving] = React.useState(false);
  const navigate = useNavigate();
  const informationRef = React.useRef(null);
  const domaineRef = React.useRef(null);
  const diplomeRef = React.useRef(null);
  const resumeRef = React.useRef(null);
  const choixLocalisationRef = React.useRef(null);

  const pageRefs = [informationRef, domaineRef, diplomeRef, choixLocalisationRef, resumeRef];

  const pages = [
    {
      name: "Information AMI",
      component: <InformationAMiPage ref={informationRef} refresh={currentPage === 0} />,
    },
    {
      name: "Domaine et Sous-Domaine",
      component: <DomaineSousDomainePage ref={domaineRef} />,
    },
    {
      name: "Diplôme minimum requis",
      component: <DiplomeRequisPage ref={diplomeRef} />,
    },
    {
      name: "Choix de localisation",
      component: <ChoixLocalisation ref={choixLocalisationRef} />,
    },
    {
      name: "Résumé",
      component: <Resume ref={resumeRef} />,
    },
  ];

  const saveCurrentStep = async () => {
    const currentRef = pageRefs[currentPage]?.current;
    if (!currentRef || typeof currentRef.save !== "function") {
      return true;
    }

    setIsSaving(true);
    try {
      const result = await currentRef.save();
      return result !== false;
    } finally {
      setIsSaving(false);
    }
  };

  const handleNext = async () => {
    if (currentPage >= pages.length - 1) {
      navigate("/list_candidature");
      return;
    }

    const canProceed = await saveCurrentStep();
    if (canProceed) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (currentPage > 0) {
      setCurrentPage((prev) => prev - 1);
    }
    else if (currentPage === 0){
      navigate("/list_candidature");
    }
  };

  return (
    <MainContainer {...headerDataAdmin}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, md: 3 },
          borderRadius: 2,
          border: 1,
          borderColor: "divider",
          backgroundColor: "#FFFFFF",
        }}
      >
        <Grid container spacing={2} direction={"column"}>
          <Grid item xs={12}>
            <Stack
              direction={{ xs: "column", md: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", md: "center" }}
              spacing={2}
              sx={{ mb: 1 }}
            >
              <Box>
                {/* <Typography variant="overline" color="primary" fontWeight={700}>
                  Appel à manifestation d'intérêt
                </Typography>
                <Typography variant="h5" fontWeight={800}>
                  Création AMI
                </Typography> */}
                <Typography variant="body2" color="text.secondary">
                  Étape {currentPage + 1} sur {pages.length} - {pages[currentPage]?.name}
                </Typography>
              </Box>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                p: { xs: 1, md: 1.5 },
                borderRadius: 2,
                backgroundColor: "#F8FAFC",
              }}
            >
              <AppStepper
                customSteps={pages.map((page) => page.name)}
                activeStep={currentPage}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>{pages.at(currentPage)?.component}</Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <CardActions >
            <Grid
              container
              // spacing={2}
              direction={"row"}
              justifyContent={"space-between"}
            >
              <Button variant="outlined" onClick={handleBack} disabled={isSaving}>
                Retour
              </Button>
              <LoadingButton
                variant={currentPage === pages.length - 1 ? "contained" : "outlined"}
                onClick={handleNext}
                disabled={isSaving}
                loading={isSaving}
                loadingIndicator="Enregistrement..."
              >
                {currentPage === pages.length - 1 ? "Valider" : "Enregistrer & Suivant"}
              </LoadingButton>
            </Grid>
          </CardActions>
        </Grid>
      </Paper>
    </MainContainer>
  );
};

export default CreationAMI;
